(function ($) {
  DJ.addBehavior('accordion', '.accordion', {
    attach: function () {
      const accordion = $(this);
      const accordionItem = $('.accordion-item', accordion);
      const accordionTrigger = $('.accordion-item__trigger', accordion);
      const accordionPanel = $('.accordion-item__panel', accordion);
      const scrollWrapper = $('.js-scroll-wrapper');
      const mq = window.matchMedia('(max-width: 767px)');
      const accordionAnchorMode = accordion.hasClass('accordion--with-anchors');
      const locationHash = window.location.hash;

      const accordionScroll = (query) => {
        if (query.matches) {
          scrollWrapper.each(function () {
            if ($(this).height() < 450) {
              $(this).addClass('hide-scrollbar');
            }
          });

          jcf.replace(scrollWrapper, 'Scrollable');
        }
      };

      const openItemOnInit = (itemTrigger, itemPanel) => {
        setTimeout(() => {
          accordionTrigger.attr('aria-expanded', 'false');
          accordionPanel.attr('hidden', '');
          itemTrigger.attr('aria-expanded', 'true');
          itemPanel.removeAttr('hidden');
        }, 1);
      };

      accordionScroll(mq);
      mq.addListener(accordionScroll);

      if (accordionAnchorMode) {
        accordionItem.removeAttr('id');

        if (locationHash) {
          const anchorItem = $(`.${locationHash.substring(1)}`, accordion);

          openItemOnInit($('.accordion-item__trigger', anchorItem), $('.accordion-item__panel', anchorItem));
        } else {
          openItemOnInit(accordionTrigger.first(), accordionPanel.first());
        }
      } else {
        openItemOnInit(accordionTrigger.first(), accordionPanel.first());
      }

      accordionTrigger.click((e) => {
        e.preventDefault();
        e.stopPropagation();

        const { target } = e;
        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const active = accordion[0].querySelector('[aria-expanded="true"]');

        if (active) {
          active.setAttribute('aria-expanded', 'false');
          document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');
        }
        if (!isExpanded) {
          target.setAttribute('aria-expanded', 'true');
          document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

          $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top - 50
          }, 500);

          if (accordionAnchorMode) {
            window.location.hash = target.getAttribute('href');
          }
        }

        jcf.refresh(scrollWrapper, 'Scrollable');
      });

      accordionTrigger.keydown((e) => {
        const code = e.keyCode || e.which;

        if (code === 13 || code === 32) {
          e.preventDefault();
          e.stopPropagation();
          $(e.target).click();
        }
      });
    }
  });
})(jQuery);
